import React from "react";
import "../../../../src/pages/FormsDatasheets/CoopPreapprovalClaimForms/NewRequest/PdfDocumentStyles.scss";

export const DvrReportPdfDetail = ({ data, requirementData }) => {
  return (
    <div className="document">
      <div className="page">
        <div className="sectionHeader">DEALER DVR REPORT</div>
        <div className="rowContainer">
          <div className="row">
            <div className="column">
              <p className="field_text">Date: {data?.date || ""}</p>
              <p className="field_text">
                Dealership: {data?.profile?.name || "-"}
              </p>
              <p className="field_text">
                Contact Name: {data?.contact_name || ""}
              </p>
              <p className="field_text">Phone: {data?.phone || ""}</p>
              <p className="field_text">Fax Number: {data?.fax || ""}</p>
              <p className="field_text">Address: {data?.address || ""}</p>
              <p className="field_text">Address 2: {data?.address2 || ""}</p>
              <p className="field_text">BTA: {data?.bta || ""}</p>
              <p className="field_text">Program: {data?.program || "-"}</p>
              <p className="field_text">
                Sales Goal: {data?.sales_goal || ""}{" "}
              </p>
              <p
                className="field_text"
                style={{ wordBreak: "break-all", width: "40vw" }}
              >
                Sales Goal Wholesale: Units:{data?.whole_sale_units || "-"}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dollars:
                {data?.whole_sale_dollars || "-"}
              </p>
              <p
                className="field_text"
                style={{ wordBreak: "break-all", width: "40vw" }}
              >
                Sales Goal Retail: Units:{data?.retail_units || "-"}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dollars:
                {data?.retail_dollars || "-"}
              </p>
              <p
                className="field_text"
                style={{ wordBreak: "break-all", width: "40vw" }}
              >
                Sales Goal In Order: Units:{data?.on_order_units || "-"}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dollars:
                {data?.on_order_dollars || "-"}
              </p>
              <p className="field_text">
                Average Market Share: {data?.average_market_share || ""}
              </p>
              <p className="field_text">
                B. T. A Current Market: {data?.bta_current_market_share || ""}
              </p>
              <p className="field_text">
                Is There a Current Deficiency?:{" "}
                {data?.current_deficiency === true
                  ? "Yes"
                  : data?.current_deficiency === false
                  ? "No"
                  : null}
              </p>
              <p className="field_text">
                #Units to Correct: {data?.correct_deficiency || ""}
              </p>
              <p className="field_text">#Boats Displayed:</p>
              <p className="field_text">
                Carolina Skiff: {data?.carolina_no_of_boats || "-"}
              </p>
              <p className="field_text">
                Sea Chaser: {data?.sea_chaser_no_of_boats || "-"}
              </p>
              <p className="field_text">
                Does Dealer have a marketing/advertising Campaign?:
                {data?.advertising_campaign === true
                  ? "Yes"
                  : data?.advertising_campaign === false
                  ? "No"
                  : null}
              </p>
              <p className="field_text">Comments: {data?.comments || "-"}</p>
              <p className="field_text">
                Other Brand Currently in Stock:{" "}
                {data && data?.dvr_other_brands?.length > 0 ? null : "-"}
              </p>
              {data && data?.dvr_other_brands?.length > 0 && (
                <>
                  <div>
                    <table
                      className="table"
                      cellPadding={5}
                      cellSpacing={0}
                      style={{ width: "40vw" }}
                    >
                      <tr className="tableRow">
                        <th className="tableColHeader">Description</th>
                        <th className="tableColHeader">Qty</th>
                      </tr>
                      {data &&
                        data?.dvr_other_brands?.map((item) => {
                          return (
                            <tr className="tableRow">
                              <td className="tableCol">
                                <p className="tableCell">
                                  {item?.description || ""}
                                </p>
                              </td>
                              <td className="tableCol">
                                <p className="tableCell">{item?.qty || ""}</p>
                              </td>
                            </tr>
                          );
                        })}
                    </table>
                  </div>
                </>
              )}
              <p className="field_text">
                Our Brand Currently in Stock:{" "}
                {data && data?.dvr_our_brands?.length > 0 ? null : "-"}
              </p>
              {data && data?.dvr_our_brands?.length > 0 && (
                <>
                  <div>
                    <table
                      className="table"
                      cellPadding={5}
                      cellSpacing={0}
                      style={{ width: "40vw" }}
                    >
                      <tr className="tableRow">
                        <th className="tableColHeader">Description</th>
                        <th className="tableColHeader">Qty</th>
                      </tr>
                      {data &&
                        data?.dvr_our_brands?.map((item) => {
                          return (
                            <tr className="tableRow">
                              <td className="tableCol">
                                <p className="tableCell">
                                  {item?.description || ""}
                                </p>
                              </td>
                              <td className="tableCol">
                                <p className="tableCell">{item?.qty || ""}</p>
                              </td>
                            </tr>
                          );
                        })}
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
